import { Area } from '@ant-design/plots';
import moment from 'moment';
import { useEffect, useState } from 'react';

export const MeasurementDataChart = (props) => {
    // let data = props.data;
    const [data, setData] = useState([])
    // let data = ;
    useEffect(() => {
        let temp = []
        if (props?.data?.length > 0) {
            props?.data.map((element) => {
                let object = {
                    "date": moment(element.created_at).format('DD-MMM-YYYY'),
                    // "time": moment(element.created_at).format("hh:mm"),
                    "value": parseFloat(element?.value)
                }
                temp.push(object)
            }
            )
            setData(temp)
        }
        else {
            // console.log('clear');
            setData([])
        }
    }, [props?.data])
    // console.log(data);


    const config = {
        data,
        xField: 'date',
        yField: 'value',
        // legend: true, 
        legend: {
            layout: 'horizontal',
            position: 'right'
        },
        xAxis: {
            range: [0, 1],
        }
    };

    return (
        // <h1>MeasurementDataChart</h1>
        <Area {...config} />
    )
}
